 <script>
   import { navigate } from 'svelte-routing';
   import axios from 'axios';
   let username = '';
   let email = '';
   let password = '';
   let firstName = '';
   let lastName = '';
   let error = '';
   let success = '';

   async function handleSignUp() {
       error = '';
       success = '';
       try {
           const response = await axios.post('https://noondev.pythonanywhere.com/authapi/signup/', {
               username,
               email,
               password,
               first_name: firstName,
               last_name: lastName
           });
           console.log('Response:', response.data); // Log de la réponse pour débogage
           success = 'Inscription réussie ! Redirection vers la page de connexion...';
           // Rediriger après un court délai pour permettre l'affichage du message de succès
           setTimeout(() => {
               navigate('/login');
           }, 2000);
       } catch (err) {
           console.error('Error:', err.response); // Log de l'erreur pour débogage
           if (err.response && err.response.data) {
               error = err.response.data.error || 'Inscription échouée. Veuillez vérifier vos informations.';
           } else {
               error = 'Inscription échouée. Une erreur s\'est produite.';
           }
       }
   }
</script>

<style>
   .signup-container {
       display: flex;
       flex-direction: column;
       align-items: center;
       justify-content: center;
       height: 100vh;
       background-color: #f9f9f9;
       padding: 20px;
   }

   h1 {
       color: #333;
   }

   form {
       display: flex;
       flex-direction: column;
       width: 300px;
   }

   input {
       margin-bottom: 10px;
       padding: 10px;
       border: 1px solid #ccc;
       border-radius: 5px;
   }

   button {
       padding: 10px;
       background-color: #0070f3;
       color: white;
       border: none;
       border-radius: 5px;
       cursor: pointer;
   }

   button:hover {
       background-color: #005bb5;
   }

   p {
       color: red;
   }

   .success {
       color: green;
   }
</style>

<div class="signup-container">
   <h1>Inscription</h1>
   <form on:submit|preventDefault={handleSignUp}>
       <input type="text" bind:value={username} placeholder="Nom d'utilisateur" required />
       <input type="email" bind:value={email} placeholder="Email" required />
       <input type="password" bind:value={password} placeholder="Mot de passe" required />
       <input type="text" bind:value={firstName} placeholder="Prénom" required />
       <input type="text" bind:value={lastName} placeholder="Nom de famille" required />
       <button type="submit">S'inscrire</button>
       {#if error}
           <p>{error}</p>
       {/if}
       {#if success}
           <p class="success">{success}</p>
       {/if}
   </form>
</div>


<!--
const response = await axios.post('https://noondev.pythonanywhere.com/authapi/signup/', {
const response = await axios.post('http://127.0.0.1:8000/authapi/login/', {
-->